// extracted by mini-css-extract-plugin
export default {"wrap":"poll_wrap__mZzra","absence__panel":"poll_absence__panel__oBp0-","btnGroup":"poll_btnGroup__ukWOW","actions":"poll_actions__BtYty"};